<template>
  <div class="config">

    <div class="row">
      <div class="col-6 drag-super-cont">
        <!-- <h2 class="tab-title">{{ $t("Configuration") }}</h2> -->
        <div style="position: relative">

          <h3 style="opacity: 0.5; margin-bottom:30px;">Version: 0.1.154 [18.07.2025]</h3>
        </div>


        <!-- <md-switch v-model="openBlank" @change="onChangeOpenBlank">Open options in a new tab</md-switch> -->


        

        <md-field>
          <label>Date format</label>
            <md-select v-model="dateFormat"  placeholder="Date format">
              <md-option value="DD.MM.YYYY">DD.MM.YYYY</md-option>
              <md-option value="DD-MM-YYYY">DD-MM-YYYY</md-option>
              <md-option value="DD. MMM YYYY">DD. MMM YYYY</md-option>
              <md-option value="YYYY.MMMM YYYY">YYYY.MMMM YYYY</md-option>
              <md-option value="YYYY.MM.DD">YYYY.MM.DD</md-option>
              <md-option value="YYYY-MM-DD">YYYY-MM-DD</md-option>
              <md-option value="YYYY/MM/DD">YYYY/MM/DD</md-option>
              <md-option value='EEE, MMM D, "yy'>EEE, MMM D, "yy</md-option>
              <md-option value="D. MMMM y">D. MMMM y</md-option>
              <md-option value="DD/MM/yyy">DD/MM/yyy</md-option>
              <md-option value="M/D/YYYY">M/D/YYYY</md-option>
              <md-option value="MMMM yyyy">MMMM yyyy</md-option>
            </md-select>
          </md-field>



        <md-field>
          <label>Time format</label>
            <md-select v-model="timeFormat"  placeholder="Date time format">
              <md-option value="HH:mm:ss">HH:mm:ss</md-option>
              <md-option value="HH:mm">HH:mm</md-option>
              <md-option value=" ">No time</md-option>
             
            </md-select>
          </md-field>




        <md-field >
          <label>Database</label>
          <md-input v-model="db" value="localhost:3000/mongo" disabled style="opacity: 0.5;"></md-input>
        </md-field>
   

        <div style="margin: 60px 0;">
          <h3 style="margin-bottom: 15px; opacity: 0.8;">Email template settings</h3>

     <md-field>
          <label>Company Name</label>
          <md-input v-model="companyName" value="Cartago" required></md-input>
        </md-field>

        <div class="md-layout-item ">
          <img :src="this.imageFile" alt="imageFile" style="max-height: 80px;">
        </div>

        <md-field class="md-layout-item ">
          <label>File</label>
          <md-file v-model="imageFile" @md-change="validateFile" accept="image/*" />
        </md-field>
        <md-button style="margin-top: 35px;" class="md-raised md-primary align-right-btn" @click="saveConfig()">{{ $t("Save config") }}</md-button>
        </div>
        <div style="margin: 160px 0;">
          <h2 style="margin-bottom: 25px">Schedule job - Send reminders and check expired transactions</h2>

          <md-field style="opacity: 0.7;">
            <label>Frecuency</label>
            <md-select v-model="intervalType" name="country" id="country" placeholder="Interval" disabled>
              <md-option value="4">Hourly*</md-option>
              <md-option value="3">Daily</md-option>
              <md-option value="1">Weekly</md-option>
              <md-option value="2">Monthly</md-option>
            </md-select>
          </md-field>

          <md-field v-if="intervalType == 1"  v-model="intervalDay">
            <md-select name="country" id="country" placeholder="Day">
              <md-option value="1">Monday</md-option>
              <md-option value="2">Tuesday</md-option>
              <md-option value="3">Wednesday</md-option>
              <md-option value="4">Thursday</md-option>
              <md-option value="5">Friday</md-option>
              <md-option value="6">Saturday</md-option>
              <md-option value="7">Sunday</md-option>
            </md-select>
          </md-field>


          <md-field v-if="intervalType == 2" v-model="intervalDate">
            <label>Date</label>
            <md-input type="number" value="30" required></md-input>
          </md-field>


          <md-field v-if="intervalType != 4">
            <label>Time</label>
            <md-input value="00:00:00" required v-model="intervalTime"></md-input>
          </md-field>
          <div style="display: none;">
          
            <vue-timepicker format="HH:mm:ss"></vue-timepicker>
          </div>



          <md-field>
          <label>Days to send Expiration alert email</label>
<md-input type="number" v-model="daysCancelEmail" value="7" disabled style="opacity: 0.5;"></md-input>
     
      </md-field>

          <div>
            <small>Controls</small>

   
            <md-button :disabled="runningJob" class="md-icon-button md-raised md-primary" @click="startJob()">
              <md-icon>play_arrow</md-icon>
              <md-tooltip md-direction="top">
 Start scheduled job        
    </md-tooltip>
            </md-button>

            <md-button :disabled="!runningJob" class="md-icon-button md-raised md-accent" @click="stopJob()">
              <md-icon>stop</md-icon>
              <md-tooltip md-direction="top">
 Stop scheduled job        
    </md-tooltip>
            </md-button>
            <md-button class="md-icon-button md-raised" @click="restoreDefault()">
              <md-icon>cached</md-icon>
              <md-tooltip md-direction="top">
Restore default       
    </md-tooltip>
            </md-button>
            <md-button class="md-icon-button md-raised md-primary" @click="saveInterval()">
              <md-icon>save</md-icon>
              <md-tooltip md-direction="top">
 Save interval time        
    </md-tooltip>
            </md-button>

            
          </div>
          <md-button class="md-raised md-primary" @click="runRemindJob">Run job now</md-button>
        </div>


       <!-- <md-button
          class="md-raised md-primary align-right-btn"
         
          >{{ $t("Download DB Backup") }}</md-button
        > -->

      </div>
    </div>

    <!-- Errors -->
    <md-snackbar md-position="center" :md-duration="3000" :md-active.sync="showError" md-persistent>
      <span>{{ errorMsg }}</span>
    </md-snackbar>

    <!-- /Errors -->
    <md-dialog :md-active.sync="showDoneDialog">
      <md-dialog-title><md-icon>task_alt</md-icon>Configuration updated</md-dialog-title>
      <md-dialog-content>
        <p>
          The configurations you set were successfully updated to the system.
        </p>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button  @click="
        showDoneDialog = false;
        ">Cancel</md-button>
        <md-button class="md-primary" @click="
          $router.push({
            path: 'landing',
          });
        showDoneDialog = false;
        ">Go Home</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueTimepicker from 'vue-time-picker'

export default {
  name: "Templates",
  display: "Transitions",
  order: 7,
  components: {
    VueTimepicker,
    // draggable,
  },
  data() {
    return {
      daysCancelEmail:7,
      runningJob:true,
      openBlank: localStorage.getItem('openBlank') === 'true',
      intervalType: 0,
      intervalDay:'',
      intervalDate:null,
      intervalTime:'00:00:00',
      imageFile: "",
      dateFormat: "DD-MM-YYYY",
      dateTimeFormat: "DD-MM-YYYY hh:mm A",
      timeFormat: "hh:mm",
      db: "localhost:3000/mongo",
      companyName: "Cartago",
      colors: [
        "#7CB9E8",
        "#9966CC",
        "#E52B50",
        "#F19CBB",
        "#3B7A57",
        "#FFBF00",
        "#FF7E00",
        "#841B2D",
        "#008000",
        "#007FFF",
        "#87421F",
      ],
      showError: false,
      errorMsg: '',
      showDialog: false,
      showDoneDialog: false,
      showEmailDialog: false,
      singpdf: null,
      tcdoc: null,
      anyOrder: true,
      ccs: [],
      validCcs: [],
      emailDialogDataInit: null,
      emailDialogData: {
        name: "",
        email: "",
        valid: true
      },
      emailDialogEditMode: false,
      activeList: null,
      assignColor: false,

      drag: false,
    };
  },
  watch:{
    timeFormat(){
  this.dateTimeFormat=this.dateFormat+' '+this.timeFormat;
},
  },
  methods: {
    onChangeOpenBlank(val) {
      localStorage.setItem('openBlank', val);
    },
    validateFile(event) {
      const reader = new FileReader();
      if (event[0]) {
        //reader.readAsText(event[0], "UTF-8");
        reader.readAsDataURL(event[0]);
        reader.onloadend = () => {
          this.imageFile = reader.result.toString();
        }
      }
    },
    runRemindJob() {

      axios({
        method: "get",
        url: "/sign/check_expired",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        }
      })
        .then((response) => {
          console.log("SUCCESS!!");

          console.log(response.data)
        })
        .catch(function () {
          console.log("FAILURE!!");

        });

    },
    restoreDefault(){
      this.intervalType= 3;
      this.intervalTime='00:00:00';
    },
    stopJob(){
      const vm=this;
      vm.runningJob=false;
      axios({
      method: "get",
      url: "/config/stopJob",
      baseURL: process.env.VUE_APP_BASE_API,
      headers: {
        Authorization:
          "Bearer " + Vue.prototype.$userData.tokens.access.token,
      }
    }).then(() => {
      vm.showDoneDialog = true;
        })
        .catch(function () {
          console.log("FAILURE!!");

        });
    },
    startJob(){
      const vm=this;
      vm.runningJob=true;
      axios({
      method: "get",
      url: "/config/startJob",
      baseURL: process.env.VUE_APP_BASE_API,
      headers: {
        Authorization:
          "Bearer " + Vue.prototype.$userData.tokens.access.token,
      }
    }).then(() => {
      vm.showDoneDialog = true;
        })
        .catch(function () {
          console.log("FAILURE!!");

        });
    },
    saveInterval(){
      var vm = this;
      const timeOffset=new Date().getTimezoneOffset()/60;
      let timeArray=(vm.intervalTime || '00:00:00').split(':');
      let utcHour =Number(timeArray[0])+timeOffset;

      if(utcHour>23){
        utcHour = utcHour -24;
      }else if (utcHour<0){
        utcHour = utcHour +24;
      }

      timeArray[0]=utcHour<10?('0'+utcHour):utcHour;
      let intervalTimeUTC=timeArray.join(':');

      var data = [
      {
        key: 'intervalType',
        value: vm.intervalType
      },
      {
        key: 'intervalDay',
        value: vm.intervalDay
      },
      {
        key: 'intervalDate',
        value: vm.intervalDate
      },
      {
        key: 'intervalTime',
        value: intervalTimeUTC
      },
    ];


      axios({
        method: "post",
        url: "/config/jobConfig",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: data
      })
        .then(() => {
          vm.runningJob=true;
          localStorage.setItem('intervalType',vm.intervalType);
localStorage.setItem('intervalDay',vm.intervalDay);
localStorage.setItem('intervalDate',vm.intervalDate);
localStorage.setItem('intervalTime',vm.intervalTime);
vm.showDoneDialog = true;
        })
        .catch(function () {
          console.log("FAILURE!!");

        });




    },

    saveConfig() {


      var vm = this;
      var data = [{
        key: 'imageFile',
        value: vm.imageFile
      },
      {
        key: 'dateFormat',
        value: vm.dateFormat
      },
      {
        key: 'dateTimeFormat',
        value: vm.dateTimeFormat
      },
      {
        key: 'db',
        value: vm.db
      },
      {
        key: 'companyName',
        value: vm.companyName
      }];



      axios({
        method: "post",
        url: "/config/config",
        baseURL: process.env.VUE_APP_BASE_API,
        headers: {
          Authorization:
            "Bearer " + Vue.prototype.$userData.tokens.access.token,
        },
        data: data
      })
        .then(() => {
          console.log("SUCCESS!!");
          localStorage.setItem("generalConfiguration", JSON.stringify({
            "imageFile": vm.imageFile,
            "dateFormat": vm.dateFormat,
            "dateTimeFormat": vm.dateTimeFormat,
            "timeFormat": vm.timeFormat,
            "db": vm.db,
            "companyName": vm.companyName,
          }));
          const df=localStorage.getItem("generalConfiguration") ? JSON.parse(localStorage.getItem("generalConfiguration"))["dateFormat"] : "YYYY-MM-DD";
          Vue.prototype.$generalConfiguration = {
            dateTimeFormat: localStorage.getItem("generalConfiguration") ? JSON.parse(localStorage.getItem("generalConfiguration"))["dateTimeFormat"] : "YYYY-MM-DD hh:mm A",
            dateFormat: df,
          }
          this.$material.locale.dateFormat =df;
          Vue.material.locale.dateFormat = df;
          console.log('df');
          console.log(df);
          console.log(Vue);
          console.log(Vue.prototype.$generalConfiguration)
          vm.showDoneDialog = true;
        })
        .catch(function () {
          console.log("FAILURE!!");

        });

    },


    getPermission(name) {
      const permissions = Vue.prototype.$userData.permissions|| [];
      if (!permissions.includes(name)) {
        this.$router.push("Landing");
      }
    },

  },
  computed: {},
  created() {
    var vm = this;
    this.getPermission('config');


    
      
      
      

    this.intervalType=localStorage.getItem('intervalType')||0;
this.intervalDay=localStorage.getItem('intervalDay')||'';
this.intervalDate=localStorage.getItem('intervalDate')||null;
this.intervalTime=localStorage.getItem('intervalTime')||'00:00:00';


    if (localStorage.getItem('config')) {
      const defaultConf = JSON.parse(localStorage.getItem('config'))
      vm.imageFile = defaultConf["imageFile"] ? defaultConf["imageFile"] : vm.imageFile;
      vm.dateFormat = defaultConf["dateFormat"] ? defaultConf["dateFormat"] : vm.dateFormat;
      vm.dateTimeFormat = defaultConf["dateTimeFormat"] ? defaultConf["dateTimeFormat"] : vm.dateTimeFormat;
      vm.db = defaultConf["db"] ? defaultConf["db"] : vm.db;
    }

    axios({
      method: "get",
      url: "/config/config",
      baseURL: process.env.VUE_APP_BASE_API,
      headers: {
        Authorization:
          "Bearer " + Vue.prototype.$userData.tokens.access.token,
      }
    })
      .then((response) => {
        console.log("SUCCESS!!");
        var configObj = {};
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index];
          if(element.key=='intervalTime'){

            const timeOffset=new Date().getTimezoneOffset()/60;
      let timeArray=(element.value|| '00:00:00').split(':');
      let localHour =Number(timeArray[0])-timeOffset;

      if(localHour>23){
        localHour = localHour -24;
      }else if (localHour<0){
        localHour = localHour +24;
      }

      timeArray[0]=localHour<10?('0'+localHour):localHour;



            element.value =timeArray.join(':');
          }


          vm[element.key] = element.value;
          if (element.key) {
            configObj[element.key] = element.value;
          }
        }
        const timeF=(vm.dateTimeFormat || '').split(' ').pop();
        vm.timeFormat = timeF;
            configObj.timeFormat= timeF;
        
        localStorage.setItem("generalConfiguration", JSON.stringify(configObj));
        Vue.prototype.$generalConfiguration = {
          dateTimeFormat: localStorage.getItem("generalConfiguration") ? JSON.parse(localStorage.getItem("generalConfiguration"))["dateTimeFormat"] : "YYYY-MM-DD",
          dateFormat: localStorage.getItem("generalConfiguration") ? JSON.parse(localStorage.getItem("generalConfiguration"))["dateFormat"] : "YYYY-MM-DD hh:mm A",
        }
        console.log(Vue.prototype.$generalConfiguration)

      })
      .catch(function () {
        console.log("FAILURE!!");

      });


      axios({
      method: "get",
      url: "/config/isJobStarted",
      baseURL: process.env.VUE_APP_BASE_API,
      headers: {
        Authorization:
          "Bearer " + Vue.prototype.$userData.tokens.access.token,
      }
    })
      .then((response) => {
vm.runningJob=response.data.isJobStarted;
      })
      .catch(function () {
        console.log("FAILURE!!");

      });


  }
};
</script>

<style lang="scss">
.tab-title {
  color: #a5a5a5;
  margin-bottom: 30px;
}

.send {
  margin: 10px;
}

.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0;
}

.drag-super-cont {
  min-width: 400px;
  width: 70%;
  margin: auto;
  margin-bottom: 50px;
}

.list-group {
  min-height: 20px;
  list-style-type: none;
  padding-left: 0;
  position: relative;
}

.add-btn-text {
  position: absolute;
  right: 50px;
  margin-top: 6px;
  font-weight: bold;
  color: #e94e1b;
}

.drag-disabled {
  cursor: default !important;
}

.list-group-item {
  cursor: move;
  display: flex;
  border: 1px solid #ccc;
  margin-bottom: 10px;

  .order {
    display: flex;
    padding-left: 10px;
    border-right: 1px solid #ccc;
    transition: all 1s ease;
    width: 67px;

    span {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.25em;
      color: #ccc;
      transition: all 1s ease;
      opacity: 1;
    }

    .order-input-cont {
      width: 30px;
    }

    .order-input {
      font-size: 1.25em;
      color: #ccc;
      background: none;
      border: none !important;
      width: 30px;

      &:focus {
        outline: none;
      }
    }

    .material-icons {
      margin-right: 5px;
      font-size: 1.5em;
      width: 21px;
    }
  }

  .any-order {
    width: 0;
    padding-left: 0;

    span {
      width: 0;
      margin: 0;
      opacity: 0;
    }
  }

  .md-chips.md-field {
    padding-top: 5px;
    width: 80%;
    margin: 0 10px;
    min-height: 40px;

    &:after {
      background: none;
    }
  }
}

div.order-switch:not(.any-order-switch) span,
.order-switch .md-switch.md-checked .md-switch-label {
  color: #0065ba;
  font-weight: bold;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.order-switch {
  display: flex;

  span {
    margin-right: 16px;
  }

  .md-switch {
    margin: 0;
  }
}

.align-right-btn {
  float: right;
  top: -10px;
  right: -10px;
}

.md-invalid {
  .md-chip {
    background-color: #ff5252;
    color: #fff;
  }
}

.cc-title {
  margin-bottom: 0;
  margin-top: 40px;
}

a.contunue {
  color: white !important;
  text-decoration: none !important;
}

.md-tooltip {
  height: 32px;
  font-size: 14px;
  line-height: 32px;
}</style>